export default __webpack_public_path__ + "static/media/hackerearth.e73d4d56.svg";